export const uk = {
    today: 'Сегодня',
    tomorrow: 'Завтра',
    yesterday: 'Вчера'
};
